// extracted by mini-css-extract-plugin
export var body = "_3j-1";
export var bodyPadded = "_3j-2";
export var chevron = "_3j-4";
export var chevronOpen = "_3j-5";
export var header = "_3j-0";
export var icon = "_3j-3";